import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { X, User } from "lucide-react";

const ANIM_MS = 280;

const FeedbackSidebar = ({ item, onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) setVisible(true);
    else requestAnimationFrame(() => setVisible(true));

    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  const handleClose = () => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return onClose?.();
    setVisible(false);
    setTimeout(() => onClose?.(), ANIM_MS);
  };

  useEffect(() => {
    const esc = (e) => e.key === "Escape" && handleClose();
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, []);

  const overlayStyle = {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.35)",
    zIndex: 999,
    opacity: visible ? 1 : 0,
    transition: `opacity ${ANIM_MS}ms ease`,
  };

  const sidebarStyle = {
    position: "fixed",
    top: 0,
    right: 0,
    width: "50vw",
    maxWidth: "100vw",
    height: "100vh",
    background: "#fff",
    boxShadow: "-2px 0 16px #0002",
    zIndex: 1000,
    padding: 32,
    overflowY: "auto",
    transform: visible ? "translateX(0)" : "translateX(100%)",
    transition: `transform ${ANIM_MS}ms cubic-bezier(0.22, 1, 0.36, 1)`,
  };

  return createPortal(
    <>
      <div style={overlayStyle} onClick={handleClose} />
      <div style={sidebarStyle} role="dialog" aria-modal>
        <button
          onClick={handleClose}
          style={{
            position: "absolute",
            top: 16,
            right: 24,
            background: "none",
            border: "none",
            cursor: "pointer",
          }}
          aria-label="Close"
        >
          <X size={24} />
        </button>

        <h2 style={{ marginBottom: 12, fontSize: 20, color: "#1e293b" }}>
          Full Feedback
        </h2>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 20,
          }}
        >
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              background: "#E0E7FF",
              display: "grid",
              placeItems: "center",
            }}
          >
            <User />
          </div>
          <div>
            <div style={{ fontWeight: 600 }}>{item.traineeName}</div>
            <div style={{ fontSize: 13, color: "#64748b" }}>
              {item.traineeEmail}
            </div>
          </div>
        </div>

        <p style={{ lineHeight: 1.6, fontSize: 15, color: "#374151", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          {item.feedback}
        </p>
      </div>
    </>,
    document.body
  );
};

export default FeedbackSidebar;
